import React, {useState, useRef, useEffect} from 'react'

import Slider from "react-slick";
import axios from 'axios';


import {componentMount} from "@common-hooks/component-mount"
import {setPathForRouter} from "@common-helpers/set-rout-path"

import {bemClassName} from 'bem-components-connector'

import logo from "./img/logo.svg";

import arrow from "./img/arrow.svg";

import Trainings from "./img/trainings.png";
import FoodPlan from "./img/food-plan.png";
import Support from "./img/support.png";
import Food from "./img/food.png";
import Exercs from "./img/exercs.png";
import Garant from "./img/garant.svg";


import Illustration1 from "./img/illustration-1.svg"
import Illustration2 from "./img/illustration-2.svg"
import Illustration2eng from "./img/illustration-2-eng.svg"
import Chart from './img/chart.svg'
import ChartNoData from './img/chart-no-data.svg'
import ChartNoDataEng from './img/chart-no-data-eng.svg'
import FoodPlanEng from './img/food-plan-eng.png'
import TrainingsEng from "./img/trainings-eng.png";
import SupportEng from "./img/support-eng.png";

import {getNextDay} from 'date-helper-js';

import ProtectedImgs from './img/protected.png'
import Cards from './img/cards.svg'

import {Footer} from '@common-layout-components/footer'
import {Modal} from '@common-components/modal'

import moment from 'moment-with-locales-es6';

import './style.scss'
import '../../../components/ui/btn/style.scss'

function importAllImages(r) {
    let images = {}
    r.keys().map((item, index) => {
        images[item.replace('./', '').replace(/\.(png|jpe?g|svg)$/, '')] = r(item).default
    })
    return images
}

const images = importAllImages(require.context('./img/slides', false, /\.(png|jpe?g|svg)$/))

const getSecondsFromMinute = (m) => {
    return m * 60
}

const getMinutesFromSeconds = (sec) => {
    var h = sec/3600 ^ 0;
    var m = (sec-h*3600)/60 ^ 0 ;
    var s = sec-h*3600-m*60 ;

    if (s < 10) {
        s = `0${s}`
    }

    if (m < 10) {
        m = `0${m}`
    }

    return `${m}:${s}`
}

let seconds = getSecondsFromMinute(10),
    minutes = getMinutesFromSeconds(seconds),
    timer = null

const getDateText = (Date) => {

    let day = Date.getDate(),
        month = Date.getMonth()+1,
        fullY = Date.getFullYear()

    if (day.toString().length === 1) {
        day = '0'+day
    }

    if (month.toString().length === 1) {
        month = '0'+month
    }

    return `${day}.${month}.${fullY}`
}

const settings = {
    dots: true,
    infinite: true,
    arrows: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <img src={arrow} alt="ar"/>,
    prevArrow: <img src={arrow} alt="ar"/>,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 414,
            settings: {
                arrows: false,
                slidesToShow: 1,
            }
        },
    ]
};

export const PlanForLoseWeight = ({
                                     nextRout,
                                     nextPageId,
                                     answersOnQuestions
                                 }) => {


    const trialId = localStorage.getItem('trialId'),
          trialPrice = localStorage.getItem('trialPrice'),
          {units, weightKg, weightLb, neededWeight, needWeightKg} = answersOnQuestions,
          dateStart = new Date(),
          startDateTxt = getDateText(dateStart),
          finishDate = getNextDay(dateStart, 44),
          finishDateTxt = getDateText(finishDate)
        
    let discount = null

    switch (trialPrice) {
        case '49':
        case '0.9':
            discount = '94%'
        break
        case '99':
            discount = '89%'
        break
        case '4.9':
            discount = '67%'
        break
        case '490':
            discount = '45%'
        break
        case '8.9':
            discount = '40%'
        break
    }


    const currentWeight = units === 'mt' ? weightKg : Math.ceil(+weightLb/2.2046),
          needWeight = needWeightKg,
          remainderWeight = currentWeight - needWeightKg
    
    const [timerTime, setTimerTime] = useState('10:00'),
          block = bemClassName('plan-for-lose-weight'),
          startTimer = () => {

              timer = setInterval(() => {

                  setTimerTime((timerTime) => {

                      const [minutes, seconds] = timerTime.split(':'),
                          secondsFromMinutes = getSecondsFromMinute(minutes),
                          resultSeconds = (secondsFromMinutes + Number(seconds)) - 1,
                          minuteResult = getMinutesFromSeconds(resultSeconds)

                      if (minuteResult === '00:00') {
                          clearInterval(timer)
                          return '00:00'
                      }

                      return minuteResult

                  })





              }, 1000)

          }

    componentMount(() => {
        startTimer()
    });

    const slides = Object.values(images).map((item, index) => {
        return (<img src={item} alt="" key={index} />)
    })

    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const openModalHandler = async (event) => {
        event.preventDefault();

        const {data} = await axios.get(event.target.href, {
            headers: {
                'x-requested-with': 'XMLHttpRequest',
            },
            responseType: 'html',
        });

        setModalOpen(true);
        setModalContent(data);
        document.querySelector('.modal_open').scrollTop = 0;
    },
    language = localStorage.getItem('lang')

    const [isDisabled, setIsDisabled] = useState(false),

    onChangeCheckbox = (e) => {
        setIsDisabled(!isDisabled)
    },
    
    myRef = useRef(null),
    executeScroll = () => myRef.current.scrollIntoView({block: "center", behavior: "smooth"})

    moment.locale('ru')

    useEffect(() => {
        if (localStorage.getItem('landing-url') === '/landing/21'){
            setIsDisabled(!isDisabled)
        }
    }, []);

    return (
        <div className={block()} >
            <div className={block('fix-block')}>
                <div className={block('fix-block-inner')}>
                    <img src={logo} />

                    <span>
                        {language === 'eng'
                            ? 'Fair price within: '
                            : 'Справедливая цена в течение: '
                        }
                    </span>
                    <span className={'time'}>00:{timerTime}</span>
                </div>
            </div>

            <div className={block('container')}>


                <div className={block('wrapper')}>


                    <div className={block('first-row')}>

                        <div className={'col'}>

                            {language === 'eng'
                                ? <h1 className={'h1 sc'}>Get a plan for nurturing healthy habits <span className={'reg'}>and losing weight at a fair price!</span></h1>
                                : <h1 className={'h1 sc'}>Получите план по воспитанию здоровых привычек <span className={'reg'}>и похудению по справедливой цене!</span></h1>
                            }

                            <div className={`${block('grad-section')}`}>
                                {language === 'eng'
                                    ? 'Get the tool for the transition to a healthy diet, kits of effective workouts and mental attitudes for weight loss'
                                    : 'Получите инструмент для перехода к здоровому питанию, наборы эффективных тренировок и психологических установок для похудения'
                                }
                            </div>

                            <div className={`${block('border-section')}`} ref={myRef}>
                                <h2 className={'txt-c'}>
                                    {language === 'eng'
                                        ? 'Get it at a fair price'
                                        : 'Приобретите по справедливой цене'
                                    }

                                    {discount ? <span className={'sc'}> -{discount}</span> : null}
                                </h2>

                                <h3 className={`txt-c`} >

                                    {discount
                                        ? <>
                                            <span className={'cross-line sc'}>
                                                {language === 'eng' ? '14.90 eur' : '890 руб.'}
                                            </span>

                                            <span className={'tc'}>
                                                &nbsp; > {trialPrice} {language === 'eng' ? 'eur till' : 'руб. До'} {startDateTxt}
                                            </span>
                                        </>
                                        : <>
                                            <span className={'tc'}>
                                                {language === 'eng' ? '14.90 eur till' : '890 руб. До'} {startDateTxt}
                                            </span>
                                        </>
                                    }


                                </h3>

                                <button className={`btn btn-theme-pink ${isDisabled === false ? "disabled" : "" }`} onClick={isDisabled === true ? setPathForRouter(nextRout, nextPageId) : undefined}>
                                    <div className={'btn__background'}/>
                                    {language === 'eng' ? 'Get a personal plan' : 'Получить персональный план'}
                                </button>

                                <label>
                                    <input type="checkbox" checked={isDisabled} onChange={onChangeCheckbox}/>
                                    <div className={'checkbox'}/>
                                    <span>
                                        {language === 'eng' 
                                            ?
                                                'I accept the user agreement, I agree with the offer, service rules, recurring payments in the amount of 14.90 eur per month and other service tariffs*'
                                            :
                                                'Принимаю пользовательское соглашение, соглашаюсь с офертой, правилами сервиса, рекуррентными платежами в размере 4990 руб. и другими тарифами сервиса*'
                                        }
                                    </span>
                                </label>
                            </div>



                        </div>

                        <div className={'col first-illustration'}>

                            <img src={Illustration1} alt="il"/>

                        </div>

                        {
                            (needWeightKg)
                            ? <div className={'col'}>

                                    <h1 className={`txt-c`}>
                                        {language === 'eng' 
                                            ? 'We are sure - You will succeed in losing weight!' 
                                            : 'У Вас точно получится похудеть!'
                                        }
                                    </h1>

                                    <div className={`${block('border-section')} ${block('border-section-chart')}`}>

                                        <p className={'forecast'}>
                                            {language === 'eng' ? 'Weight loosing prognosis' : 'Прогноз похудения'}
                                        </p>

                                        <h2 className={block('y-offset')}>
                                            - {remainderWeight} {language === 'eng' ? 'kg after 44 days' : 'кг через 44 дня'}
                                        </h2>

                                        <div className={`${block('chart')} ${block('y-offset', {top: true})}`}>

                                            <div className={'up'}>
                                                {startDateTxt} <br/>
                                                {currentWeight} {language === 'eng' ? 'kg' : 'кг'}
                                            </div>

                                            <img src={Chart} alt=""/>

                                            <div className={'down'}>
                                                {finishDateTxt} <br/>
                                                {needWeightKg} {language === 'eng' ? 'kg' : 'кг'}
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            : <div className={'col'}>

                                    <h1 className={`txt-c`}>
                                        {language === 'eng' 
                                            ? 'We are sure - You will succeed in losing weight!' 
                                            : 'У Вас точно получится похудеть!'
                                        }
                                    </h1>

                                    <div className={`${block('border-section')}`}>

                                        <div className={`${block('chart')} ${block('y-offset', {top: true})}`}>
                                            {language === 'eng'
                                                ? <img src={ChartNoDataEng} alt=""/>
                                                : <img src={ChartNoData} alt=""/>
                                            }
                                        </div>

                                    </div>

                                </div>
                        }

                        <div className={'col'}>

                            <div className={block('silver-section')}>

                                <h2 className={`txt-c title-border`}>
                                    {language === 'eng' 
                                        ? 'Your program is designed to transform in these areas:' 
                                        : 'Ваша программа рассчитана на преображение в этих зонах:'
                                    }
                                </h2>

                                {language === 'eng'
                                    ? <img src={Illustration2eng} alt=""/>
                                    : <img src={Illustration2} alt=""/>
                                }

                                <p> 
                                    {language === 'eng'
                                        ? <><b>Visceral fat</b> - is the lining of your organs that increases body volume. This type of fat is the most dangerous because it affects not only your figure, but also your health and hormones.</>
                                        : <><b>Висцеральный жир</b> — это оболочка ваших органов, увеличивающая объем тела. Этот тип жира наиболее опасен, поскольку влияет не только на вашу фигуру, но и на ваше здоровье и гормональный фон.</>
                                    }
                                </p>

                                <p className={block('y-offset', {top: true})}>
                                    {language === 'eng' 
                                        ? 'We’ve already put together a personalized nutrition plan for your body type to help you lose subcutaneous and visceral fat.' 
                                        : 'Мы уже составили индивидуальный план питания для вашего типа телосложения, который будет способствовать потере подкожного и висцерального жира.'
                                    }
                                </p>

                            </div>

                        </div>

                    </div>

                    {language === 'eng'
                        ? null
                        :   <h1 className={`txt-c section-title`}>
                                Они уже похудели с Easy Fitness
                            </h1>
                    }
    
                    {language === 'eng'
                        ? null
                        :   <Slider {...settings}>
                                {slides}
                            </Slider>
                    }

                    <div className={`${block('border-section')} double-border-section`}>
                        <h2 className={'txt-c'}>
                            {language === 'eng'
                                ? 'Get it at a fair price'
                                : 'Приобретите по справедливой цене'
                            }

                            {discount ? <span className={'sc'}> -{discount}</span> : null}
                        </h2>

                        <h3 className={`txt-c ${block('y-offset')}`} >

                            {discount 
                                ?   <>
                                        <span className={'cross-line sc'}>
                                            {language === 'eng' ? '14.90 eur' : '890 руб.'}
                                        </span>

                                        <span className={'tc'}>
                                            &nbsp; > {trialPrice} {language === 'eng' ? 'eur till' : 'руб. До'} {startDateTxt}
                                        </span>
                                    </> 
                                :   <>
                                        <span className={'tc'}>
                                            {language === 'eng' ? '14.90 eur till' : '890 руб. До'} {startDateTxt}
                                        </span>
                                    </>
                            }


                        </h3>

                        <button className={`btn btn-theme-pink ${isDisabled === false ? "disabled" : "" }`} onClick={isDisabled === true ? setPathForRouter(nextRout, nextPageId) : undefined} >
                            <div className={'btn__background'}/>
                            {language === 'eng' ? 'Get a personal plan' : 'Получить персональный план'}
                        </button>

                        <label>
                            <input type="checkbox" checked={isDisabled} onChange={onChangeCheckbox}/>
                            <div className={'checkbox'}/>
                            <span>
                                {language === 'eng' 
                                    ?
                                        'I accept the user agreement, I agree with the offer, service rules, recurring payments in the amount of 14.90 eur per month and other service tariffs*'
                                    :
                                        'Принимаю пользовательское соглашение, соглашаюсь с офертой, правилами сервиса, рекуррентными платежами в размере 4990 руб. и другими тарифами сервиса*'
                                }
                            </span>
                        </label>

                    </div>

                    <div className={'screen-row'}>


                        <div className="text-col">

                            <h2>
                                {language === 'eng' ? 'What will you get?' : 'Что вы получите?'}
                            </h2>

                            <p>
                                {language === 'eng' 
                                    ? 'Professional training plan. This plan is the key to speeding up your metabolic process. All workouts are designed by professional athletes. Each workout contains a set of exercises, step-by-step instructions for performing. No need to invent and select exercises, we did it for you.' 
                                    : 'Профессиональный план тренировок. Этот план — ключ к ускорению вашего метаболического процесса. Все тренировки разработаны профессиональными спортсменами. Каждая тренировка содержит набор упражнений, пошаговую инструкцию по выполнению. Не нужно придумывать и подбирать упражнения, мы сделали это за вас.'
                                }
                            </p>

                        </div>

                        <div className={'screen'}>
                            <span>
                                {language === 'eng' ? 'Workout plan' : 'План тренировок'}
                            </span>
                            <img src={language === 'eng' ? FoodPlanEng : FoodPlan} alt=""/>
                        </div>

                    </div>

                    <div className={'screen-row screen-row_ltr'}>

                        <div className={'screen'}>
                            <span>
                                {language === 'eng' ? 'Workout and exercise' : 'Тренировки и упражнения'}
                            </span>
                            <img src={language === 'eng' ? TrainingsEng : Trainings} alt=""/>
                        </div>

                        <div className="text-col">
                        
                            {language === 'eng'
                                ?
                                    <>
                                        <h2>Exercises to speed up the metabolism</h2>
                                        <p>Exercises to speed up the metabolism Exercises from this set will not take a lot of your time, but will significantly improve health, sleep quality and stress resistance. Lose those extra pounds with our meal plan!</p>
                                    </>
                                :
                                    <>
                                        <h2>Упражнения для ускорения метаболизма</h2>
                                        <p>Упражнения для ускорения метаболизма Этот комплекс упражнений не займет много времени, но поможет значительно улучшить состояние здоровья, качество сна и стрессоустойчивость. Избавляйтесь от лишних килограммов с помощью нашего плана питания!</p>
                                    </>
                            }

                        </div>



                    </div>

                    <div className={'screen-row'}>


                        <div className="text-col">

                            <h2>
                                {language === 'eng' ? 'Online support' : 'Онлайн поддержка'}
                            </h2>

                            <p>
                                {language === 'eng' 
                                    ? 'We are in touch 24/7 and are ready to answer any questions and help solve any problems.' 
                                    : 'Мы на связи 24/7 и готовы ответить на любые вопросы и помочь решить любые проблемы.'
                                }
                            </p>

                            <p className={block('y-offset', {top: true})}>
                                {language === 'eng' 
                                    ? 'Our support specialists will forward your request to a professional nutritionist and help you sort out any questions you may have.' 
                                    : 'Наши специалисты отдела поддержки передадут ваш запрос профессиональному диетологу и помогут разобраться со всеми вопросами, которые у вас могут возникнуть.'
                                }
                            </p>

                        </div>

                        <div className={'screen'}>
                            <span>
                                {language === 'eng' ? 'Curator support' : 'Поддержка кураторов'}
                            </span>
                            <img src={language === 'eng' ? SupportEng : Support} alt=""/>
                        </div>

                    </div>

                    <div className={`${block('first-row')} last-row`}>

                        <div className={'col'}>

                            <h2 className={'txt-c title-border'} >
                                {language === 'eng' 
                                    ? 'Lots of delicious recipes to help you lose weight as quickly as possible.' 
                                    : 'Множество вкусных рецептов, которые помогут вам максимально быстро похудеть.'
                                }
                            </h2>

                            <img src={Food} alt="fd"/>

                            <p className={'txt-c'}>
                                {language === 'eng' 
                                    ? 'All recipes are developed by professional nutritionists. The meals do not include expensive ingredients.' 
                                    : 'Все рецепты разработаны профессиональными диетологами. Блюда не включают в себя дорогие ингредиенты.'
                                }
                            </p>

                        </div>

                        <div className={`col ${block('silver-section')}`}>

                            <h2 className={'txt-c title-border'} >
                                {language === 'eng' 
                                    ? 'Effective workouts for the most common problem areas: arms, legs, buttocks and abdomen.' 
                                    : 'Эффективные тренировки для наиболее распространенных проблемных зон: руки, ноги, ягодицы и живот.'
                                }
                            </h2>

                            <img src={Exercs} alt="fd"/>

                            <p className={'txt-c'}>
                                {language === 'eng' 
                                    ? 'All exercises are created by certified trainers.' 
                                    : 'Все упражнения составлены сертифицированными тренерами.'
                                }
                            </p>

                        </div>

                    </div>

                    {language === 'eng'

                        ?
                            <div className={block('garant')}>
                                <h2>
                                    Our MONEY BACK GUARANTEE
                                </h2>
                                <p className={block('y-offset')}>
                                    We have no doubt that our program will be effective for you, and you will get visible results in 4 weeks! Otherwise, we are ready to return your money back if you can demonstrate that you followed our plan.
                                </p>
                                <p className={'last'}>
                                    Find out more about the applicable restrictions in our money back policy.
                                </p>
                                <img src={Garant} alt=""/>
                            </div>

                        :
                            <div className={block('garant')}>
                                <h2>
                                    Наша ГАРАНТИЯ ВОЗВРАТА ДЕНЕГ
                                </h2>
                                <p className={block('y-offset')}>
                                    Мы не сомневаемся, что наша программа будет для вас эффективной, и вы получите видимые результаты через 4 недели! В противном случае мы готовы вернуть Ваши деньги обратно, если вы сможете продемонстрировать, что четко следовали нашему плану.
                                </p>
                                <p className={'last'}>
                                    Узнайте больше о действующих ограничениях в нашей политике возврата денег.
                                </p>
                                <img src={Garant} alt=""/>
                            </div>
                    }

                    <div className={`${block('first-row')} text-row`}>

                        {language === 'eng'

                            ?
                                <div className={'col col-f'}>
                                    <h1>
                                        Overweight patients have a much higher risk of negative course of new coronavirus infection.
                                    </h1>

                                    <h2 className={`sc ${block('y-offset')}`}>
                                        Being overweight also increases the likelihood of decease.
                                    </h2>

                                    <p className={block('y-offset')}>
                                        This was reported by the Doctor of Medical Sciences of the Institute of Chemical Biology and Fundamental Medicine.
                                    </p>

                                    <div className={'checked-items'}>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Professionally selected exercises</span>
                                        </div>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Easy recipes for delicious and healthy dishes</span>
                                        </div>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Effective workouts for burning fat</span>
                                        </div>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Recipes are composed of simple, inexpensive ingredients</span>
                                        </div>
                                    </div>
                                </div>

                            :
                                <div className={'col col-f'}>
                                    <h1>
                                        У пациентов с лишним весом гораздо выше риск негативного течения новой коронавирусной инфекции.
                                    </h1>

                                    <h2 className={`sc ${block('y-offset')}`}>
                                        Избыточный вес повышает и вероятность летального исхода.
                                    </h2>

                                    <p className={block('y-offset')}>
                                        Об этом сообщила доктор медицинских наук Института химической биологии и фундаментальной медицины.
                                    </p>

                                    <div className={'checked-items'}>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Профессионально подобранные упражнения</span>
                                        </div>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Легкие рецепты вкусных и полезных блюд</span>
                                        </div>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Эффективные тренировки для сжигания жира</span>
                                        </div>
                                        <div className={'checked-items__item'}>
                                            <div className={'checked-items__item-checkbox'}/>
                                            <span>Рецепты составлены из простых и недорогих ингредиентов</span>
                                        </div>
                                    </div>
                                </div>
                        }
                        
                        {language === 'eng'
                            ?
                                <div className="col txt-rows">
                                    <p>By continuing, I agree to the Terms of Use, Privacy Policy, Return Policy, Terms of Subscription, Cookies Policy</p>
                                    <p>Paying {trialPrice} EUR. you starting a free trial access to the Easy Fitness service and get access to a personal training plan during the free trial period.</p>
                                    <p>Your Easy Fitness subscription will automatically renew at the end of the trial period unless you cancel at least 24 hours before the end of the paid period. If you are  not sure of how to unsubscribe, please read our Terms of Subscription.</p>
                                    <p>Your trial version will last 7 days. You can cancel your subscription at any time during this period and you will not be charged the full amount of the program</p>
                                    <p>7 days after completing a trial subscription, on {moment().locale('en').utcOffset(0).add(7, 'd').format("DD MMMM YYYY HH:mm")} GMT, you will be charged a payment in the amount of EUR 14.90 for 30 days of use (see all subscriptions in the offer).</p>
                                    <p>Easy Fitness will automatically charge EUR 14.90 from your card. every next 30 days so that you do not lose access to your account. No refunds or returns will be provided, unless you have not received the result in full compliance with the money back policy.</p>
                                    <p>To cancel your subscription, just write to e-mail: <a href={'mailto:help@easy-fitness.online'}>help@easy-fitness.online</a> or do it yourself in your personal account</p>
                                </div>
                            :
                                <div className="col txt-rows">
                                    <p>Продолжая, я соглашаюсь c Условиями использования, Политикой приватности, Политикой возврата, Условиями подписки, Политикой cookies</p>
                                    <p>Оплачивая {trialPrice} руб. вы оформляете бесплатный пробный доступ к сервису Easy Fitness и получаете доступ к персональному плану тренировок на период действия бесплатного пробного доступа. Пробный доступ начинается в день оплаты.</p>
                                    <p>Подписка Easy Fitness автоматически продлевается в конце пробного периода, если вы не отмените ее по крайней мере за 24 часа до окончания оплаченного периода. Если вы не знаете, как отменить подписку, ознакомьтесь с нашими Условиями подписки.</p>
                                    <p>Ваша пробная версия продлится 7 дней. Вы можете отменить подписку в любое время в течение этого периода, и с вас не будет взиматься полная сумма программы.</p>
                                    <p>Через 7 дней после оформления пробной подписки, {moment().utcOffset(3).add(7, 'd').format("DD MMMM YYYY HH:mm")} МСК, с вас будет списан платеж в размере 4990 руб. за 90 дней использования (все подписки смотрите в оферте). За 7 дней до этого вы получите уведомление по email.</p>
                                    <p>Easy Fitness будет автоматически снимать с вашей карты 4990 руб. каждые последующие 90 дней, чтобы вы не потеряли доступ к своей учетной записи. Никаких возмещений и возвратов не предусмотрено, кроме случаев, если вы не получили результа при полном соблюдении политики возврата денег.</p>
                                    <p>Чтобы отменить подписку, просто напишите на электронную почту: <a href={'mailto:help@easy-fitness.online'}>help@easy-fitness.online</a> или сделайте это самостоятельно в личном кабинете</p>
                                </div>
                        }
                    </div>

                    <div className={'container-footer'}>

                        <h2 className={block('y-offset')}>
                            {language === 'eng' ? 'PAYMENT IS PROTECTED' : 'Платёж защищён'}
                        </h2>

                        <img src={ProtectedImgs} className={'protected'} alt="pt"/>

                        <h2 className={block('y-offset')}>
                            {language === 'eng' ? 'WE ACCEPT FOR PAYMENT' : 'Принимаем к оплате'}
                        </h2>

                        <img src={Cards} className={'cards'} alt="pt"/>

                    </div>

                </div>

            </div>

            <div className={block('fixed-btn')}>
                <button className={`btn btn-theme-pink pulse`} onClick={isDisabled === false ? executeScroll : setPathForRouter(nextRout, nextPageId)}>
                    <div className={'btn__background'}/>
                    {language === 'eng' ? 'Get my plan' : 'Получить мой план'}
                </button>
            </div>
            <Footer theme={'pink'}>
                {language === 'eng'
                    ? <>By using this site, you consent to the use of cookies to help us make it better and you are also agree to our <a href={'/privacy'} onClick={openModalHandler}>privacy policy</a>.</>
                    : <>Используя данный сайт, вы даете согласие на использование файлов cookie, помогающих нам сделать его удобнее для вас. А также соглашаетесь с нашей <a href={'/privacy'} onClick={openModalHandler}>политикой конфиденциальности</a>.</>
                }
            </Footer>
            <Modal
                isOpen={modalOpen}
                openHandler={setModalOpen}
                theme={'big'}
            >
                {modalContent}
            </Modal>
        </div>
    )
}